import * as React from 'react';
import * as styled from './styled';
import Input, {InputVariant} from 'components/Input';
import Modal from 'components/Modal';
import Button, {ButtonVariant} from 'components/Button';
import {CreateFolderProps} from './types';

/**
 * The create folder modal.
 * @param {CreateFolderProps} props
 * @return {React.ReactElement<CreateFolderProps>}
 * @constructor
 */
export default function CreateFolder(
    props: CreateFolderProps,
): React.ReactElement<CreateFolderProps> {
  const [
    name, setName,
  ] = React.useState<string>('');

  /**
   * Render header.
   * @return {JSX.Element}
   */
  function renderHeader(): JSX.Element {
    return (
      <span>Создать и переместить в папку</span>
    );
  }

  /**
   * Render content.
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * The change event handler.
     */
    function handleChange(event: React.ChangeEvent<HTMLInputElement>): void {
      setName(event.target.value);
    }

    return (
      <styled.Content>
        <Input
          type="text"
          value={name}
          label="Введите название папки"
          placeholder="Например: Маркетинг"
          variant={InputVariant.Accent}
          onChange={handleChange}
          onKeyPress={(event) => (
            event.key === 'Enter' && (
              handleSubmit()
            )
          )}
          required
        />
      </styled.Content>
    );
  }

  /**
   * Render footer.
   * @return {JSX.Element}
   */
  function renderFooter(): JSX.Element {
    return (
      <Button
        type="submit"
        onClick={handleSubmit}
        variant={ButtonVariant.Primary}
      >
        Создать папку
      </Button>
    );
  }

  /**
   * The submit event handler.
   */
  function handleSubmit(): void {
    props.onSubmit && props.onSubmit(name);
  }

  return (
    <Modal
      {...props}
      renderHeader={renderHeader()}
      renderFooter={renderFooter()}
    >
      {renderContent()}
    </Modal>
  );
}
